// extracted by mini-css-extract-plugin
export default {"shortcutHeader":"Shortcuts_shortcutHeader__Jso6+","shortcut":"Shortcuts_shortcut__NWTIx","shortcutPic":"Shortcuts_shortcutPic__XnCCP","shortcutName":"Shortcuts_shortcutName__DrKDJ"};